var _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgEducationCdk(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 193.335,
    height: 188.312,
    viewBox: "0 0 193.335 188.312",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_7093",
    "data-name": "Group 7093",
    transform: "translate(-766.666 -411.688)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_7085",
    "data-name": "Group 7085",
    transform: "translate(16724.613 -15067)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_7085-2",
    "data-name": "Group 7085"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3055",
    "data-name": "Group 3055",
    transform: "translate(-15947.525 15496.893)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2634",
    "data-name": "Rectangle 2634",
    width: 44.951,
    height: 1.735,
    fill: "#cbdb56"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_3056",
    "data-name": "Group 3056",
    transform: "translate(-15934.614 15498.311)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2635",
    "data-name": "Rectangle 2635",
    width: 1.735,
    height: 29.763,
    fill: "#cbdb56"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_3057",
    "data-name": "Group 3057",
    transform: "translate(-15918.079 15498.311)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2636",
    "data-name": "Rectangle 2636",
    width: 1.735,
    height: 29.763,
    fill: "#cbdb56"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_3058",
    "data-name": "Group 3058",
    transform: "translate(-15946.424 15511.223)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2637",
    "data-name": "Rectangle 2637",
    width: 42.991,
    height: 1.735,
    fill: "#cbdb56"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_3067",
    "data-name": "Group 3067",
    transform: "translate(-15882.491 15480.232)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_4445",
    "data-name": "Path 4445",
    d: "M594.314,420.434a16.53,16.53,0,0,1,0-33.06h.868v15.662h15.663v.868A16.549,16.549,0,0,1,594.314,420.434Zm-.868-31.3a14.795,14.795,0,1,0,15.637,15.637H593.447Z",
    transform: "translate(-577.785 -387.374)",
    fill: "#cbdb56"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_3069",
    "data-name": "Group 3069",
    transform: "translate(-15957.947 15548.473)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_4446",
    "data-name": "Path 4446",
    d: "M390.7,633.129h-44a5.039,5.039,0,0,1-5.034-5.034V605.955a5.039,5.039,0,0,1,5.034-5.034h30.287a5.039,5.039,0,0,1,5.034,5.034v18.5Zm-44-30.473a3.3,3.3,0,0,0-3.3,3.3V628.1a3.3,3.3,0,0,0,3.3,3.3H386.5l-6.227-6.222V605.955a3.3,3.3,0,0,0-3.3-3.3Z",
    transform: "translate(-341.658 -600.921)",
    fill: "#cbdb56"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_3087",
    "data-name": "Group 3087",
    transform: "translate(-15824.264 15482.176)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3079",
    "data-name": "Group 3079",
    transform: "translate(25.907 31.564)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3078",
    "data-name": "Group 3078",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3074",
    "data-name": "Group 3074",
    transform: "translate(1.42 5.97)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_4447",
    "data-name": "Path 4447",
    d: "M862.778,544.735l-17.144-28.9a.867.867,0,0,1,.307-1.191l6.156-3.61a.868.868,0,0,1,1.185.306L870.358,540.1l-1.492.885-16.635-28.021-4.659,2.732,16.7,28.153Z",
    transform: "translate(-845.513 -510.912)",
    fill: "#cbdb56"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_3075",
    "data-name": "Group 3075",
    transform: "translate(18.621 34.94)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_4448",
    "data-name": "Path 4448",
    d: "M903.677,611.242A2.517,2.517,0,0,1,901.5,610l-2.043-3.484a.867.867,0,0,1,.311-1.188l6.244-3.64A.867.867,0,0,1,907.2,602l2.039,3.477a2.514,2.514,0,0,1-.9,3.443l-3.4,1.982A2.5,2.5,0,0,1,903.677,611.242Zm-2.28-4.853,1.6,2.734a.779.779,0,0,0,1.064.279l3.4-1.982a.779.779,0,0,0,.28-1.067l-1.6-2.73Z",
    transform: "translate(-899.341 -601.57)",
    fill: "#cbdb56"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_3076",
    "data-name": "Group 3076",
    transform: "translate(0.724 1.009)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_4449",
    "data-name": "Path 4449",
    d: "M844.9,505.694a.867.867,0,0,1-.865-.8l-.7-8.57a.868.868,0,0,1,1.374-.773l6.851,4.961a.868.868,0,0,1-.07,1.451l-6.156,3.61A.871.871,0,0,1,844.9,505.694Zm.321-7.631.431,5.316,3.818-2.239Z",
    transform: "translate(-843.335 -495.388)",
    fill: "#cbdb56"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_3077",
    "data-name": "Group 3077",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2643",
    "data-name": "Rectangle 2643",
    width: 1.735,
    height: 2.554,
    transform: "translate(0 0.878) rotate(-30.387)",
    fill: "#cbdb56"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_3086",
    "data-name": "Group 3086"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3080",
    "data-name": "Group 3080"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_4450",
    "data-name": "Path 4450",
    d: "M785.5,451.454H760.867a.868.868,0,0,1-.868-.868V394.323a.868.868,0,0,1,.868-.868h35.826a.867.867,0,0,1,.63.272l9.767,10.33a.868.868,0,0,1,.237.6v35.009h-1.735V405l-9.273-9.807H761.734v54.529H785.5Z",
    transform: "translate(-759.999 -393.455)",
    fill: "#cbdb56"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_3081",
    "data-name": "Group 3081",
    transform: "translate(10.01 14.842)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2644",
    "data-name": "Rectangle 2644",
    width: 18.959,
    height: 1.735,
    fill: "#cbdb56"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_3082",
    "data-name": "Group 3082",
    transform: "translate(10.01 23.866)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2645",
    "data-name": "Rectangle 2645",
    width: 26.833,
    height: 1.735,
    fill: "#cbdb56"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_3083",
    "data-name": "Group 3083",
    transform: "translate(10.01 32.889)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2646",
    "data-name": "Rectangle 2646",
    width: 12.051,
    height: 1.735,
    fill: "#cbdb56"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_3084",
    "data-name": "Group 3084",
    transform: "translate(10.01 41.912)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2647",
    "data-name": "Rectangle 2647",
    width: 10.986,
    height: 1.735,
    fill: "#cbdb56"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_3085",
    "data-name": "Group 3085",
    transform: "translate(34.907 0.868)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_4451",
    "data-name": "Path 4451",
    d: "M880.789,408.614H870.1a.868.868,0,0,1-.868-.868V396.17h1.735v10.709h9.818Z",
    transform: "translate(-869.236 -396.17)",
    fill: "#cbdb56"
  })))), /*#__PURE__*/React.createElement("path", {
    id: "Subtraction_25",
    "data-name": "Subtraction 25",
    d: "M36.085,40.658H32.24a12.857,12.857,0,0,1-5.77-2.669,12.756,12.756,0,0,1-5.762,2.669H16.863a17.5,17.5,0,0,1-8.674-4.423,24.644,24.644,0,0,1-5.911-7.869A26.593,26.593,0,0,1,.248,14a19.294,19.294,0,0,1,2.3-6.945A13.9,13.9,0,0,1,7.59,1.91,14.311,14.311,0,0,1,14.931,0a22.04,22.04,0,0,1,7.914,1.6A23.475,23.475,0,0,1,26.47,3.332,23.513,23.513,0,0,1,30.1,1.6,22.05,22.05,0,0,1,38.011,0,14.332,14.332,0,0,1,45.358,1.91,13.9,13.9,0,0,1,50.4,7.053,19.293,19.293,0,0,1,52.7,14a26.6,26.6,0,0,1-2.03,14.366,24.653,24.653,0,0,1-5.912,7.869,17.5,17.5,0,0,1-8.674,4.423ZM39.663,6.551,38.5,7.839c3.942,3.56,5.243,10.866,2.84,15.952a16.24,16.24,0,0,1-5.084,5.982l1,1.421a17.823,17.823,0,0,0,5.658-6.663c2.747-5.815,1.291-13.881-3.246-17.98Z",
    transform: "translate(-15886.924 15541.432)",
    fill: "#cbdb56"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_7084",
    "data-name": "Group 7084"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Union_26",
    "data-name": "Union 26",
    d: "M4,438.432v-5.957H117.118a15.943,15.943,0,0,0,0-31.885H4v-5.845H117.174a21.844,21.844,0,0,1,0,43.688Zm27.79-43.688a17.872,17.872,0,1,1,0-35.744h85.389v5.957H31.79a11.915,11.915,0,0,0,0,23.83h85.389v5.957Z",
    transform: "translate(-15931.789 15227.7)",
    fill: "#cbdb56"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_4583",
    "data-name": "Path 4583",
    d: "M644.457,522.267c-1.424-1.672.816-6.631,4.156-9.316,4.463-3.588,10.136-2.51,11.18-2.293a15.128,15.128,0,0,1-4.587,8.456C651.691,522.261,645.964,524.036,644.457,522.267Z",
    transform: "translate(-16505.346 15009.189)",
    fill: "#cbdb56"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_7086",
    "data-name": "Group 7086",
    transform: "translate(16724.613 -15067)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3059",
    "data-name": "Group 3059",
    transform: "translate(-15940.126 15481.776)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2638",
    "data-name": "Rectangle 2638",
    width: 1.735,
    height: 8.818,
    fill: "#0077b9"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_3060",
    "data-name": "Group 3060",
    transform: "translate(-15912.567 15481.776)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2639",
    "data-name": "Rectangle 2639",
    width: 1.735,
    height: 8.818,
    fill: "#0077b9"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_3061",
    "data-name": "Group 3061",
    transform: "translate(-15948.944 15485.869)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_4441",
    "data-name": "Path 4441",
    d: "M416.763,447.536h-46.93V405.015h46.93Zm-45.2-1.735h43.46V406.75h-43.46Z",
    transform: "translate(-369.833 -405.015)",
    fill: "#0077b9"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_3065",
    "data-name": "Group 3065",
    transform: "translate(-15816.398 15566.439)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3063",
    "data-name": "Group 3063",
    transform: "translate(9.013 21.294)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_4442",
    "data-name": "Path 4442",
    d: "M818.723,738.057h-5.907v-1.735h5.907a1.765,1.765,0,0,0,1.763-1.763,1.822,1.822,0,0,0-.646-1.363,5.393,5.393,0,1,1,7.186-.017,1.864,1.864,0,0,0-.664,1.38,1.765,1.765,0,0,0,1.763,1.763l2.822-.032h10.363V726.34h1.735v11.685H830.958l-2.822.032a3.5,3.5,0,0,1-3.508-3.5,3.575,3.575,0,0,1,1.24-2.671,3.624,3.624,0,0,0,1.174-3.258,3.673,3.673,0,0,0-3.2-3.091,3.623,3.623,0,0,0-2.859.907,3.654,3.654,0,0,0,.007,5.454,3.579,3.579,0,0,1,1.228,2.659A3.5,3.5,0,0,1,818.723,738.057Z",
    transform: "translate(-812.816 -723.781)",
    fill: "#0077b9"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_3064",
    "data-name": "Group 3064"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_4443",
    "data-name": "Path 4443",
    d: "M823.856,691.957h-1.735V679.6a3.5,3.5,0,0,1,3.5-3.5,3.574,3.574,0,0,1,2.671,1.241,3.624,3.624,0,0,0,3.258,1.174,3.672,3.672,0,0,0,3.091-3.2,3.655,3.655,0,0,0-6.361-2.852,3.575,3.575,0,0,1-2.656,1.227,3.5,3.5,0,0,1-3.5-3.5l0-11.318H808.934a1.765,1.765,0,0,0-1.763,1.763,1.864,1.864,0,0,0,.664,1.379,5.392,5.392,0,1,1-7.187-.016,1.82,1.82,0,0,0,.646-1.361,1.766,1.766,0,0,0-1.763-1.765H786.346v8.462h-1.735v-10.2h14.92a3.5,3.5,0,0,1,3.5,3.5A3.578,3.578,0,0,1,801.8,663.3a3.657,3.657,0,1,0,4.874.011,3.573,3.573,0,0,1-1.241-2.67,3.5,3.5,0,0,1,3.5-3.5h14.921l0,13.053a1.766,1.766,0,0,0,1.765,1.763,1.841,1.841,0,0,0,1.36-.645A5.393,5.393,0,1,1,827,678.5a1.863,1.863,0,0,0-1.379-.664,1.765,1.765,0,0,0-1.763,1.763Z",
    transform: "translate(-784.611 -657.144)",
    fill: "#0077b9"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_3066",
    "data-name": "Group 3066",
    transform: "translate(-15859.929 15478.688)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_4444",
    "data-name": "Path 4444",
    d: "M660.817,394.925H648.389V382.54h.868a11.58,11.58,0,0,1,11.557,11.514Zm-10.693-1.735h8.913a9.851,9.851,0,0,0-8.913-8.877Z",
    transform: "translate(-648.389 -382.54)",
    fill: "#0077b9"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_3070",
    "data-name": "Group 3070",
    transform: "translate(-15948.884 15559.386)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2640",
    "data-name": "Rectangle 2640",
    width: 22.01,
    height: 1.735,
    fill: "#0077b9"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_3071",
    "data-name": "Group 3071",
    transform: "translate(-15948.884 15567.606)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2641",
    "data-name": "Rectangle 2641",
    width: 10.921,
    height: 1.735,
    fill: "#0077b9"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_3072",
    "data-name": "Group 3072",
    transform: "translate(-15932.123 15567.606)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2642",
    "data-name": "Rectangle 2642",
    width: 5.25,
    height: 1.735,
    fill: "#0077b9"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_3088",
    "data-name": "Group 3088",
    transform: "translate(-15870.067 15525.496)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_4453",
    "data-name": "Path 4453",
    d: "M624.925,546.4l-1.689-.4a13.043,13.043,0,0,0-.7-8.473,15.251,15.251,0,0,0-5.869-7.044l.932-1.463a16.992,16.992,0,0,1,6.545,7.854A14.865,14.865,0,0,1,624.925,546.4Z",
    transform: "translate(-616.663 -529.019)",
    fill: "#0077b9"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_3089",
    "data-name": "Group 3089",
    transform: "translate(-15892.692 15538.18)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_4454",
    "data-name": "Path 4454",
    d: "M584.423,614.66a13.779,13.779,0,0,1-2.144-.167,14.8,14.8,0,0,1-6.373-2.7,14.807,14.807,0,0,1-6.373,2.7c-8.8,1.385-17.439-6.09-21.095-13.828-4.08-8.635-4.192-23.782,6.21-29.759,8.8-5.055,18.979.027,21.258,1.3,2.279-1.271,12.457-6.355,21.257-1.3,10.4,5.978,10.29,21.123,6.21,29.759C600.015,607.773,592.455,614.66,584.423,614.66Zm-8.517-5.052.533.414a13.3,13.3,0,0,0,6.111,2.757c7.684,1.208,15.821-5.587,19.255-12.855,3.793-8.029,3.991-22.056-5.505-27.513-8.884-5.1-19.83,1.467-19.941,1.534l-.453.277-.452-.277c-.11-.067-11.057-6.639-19.941-1.534-9.495,5.456-9.3,19.484-5.505,27.513,3.434,7.268,11.58,14.067,19.256,12.855a13.3,13.3,0,0,0,6.11-2.757Z",
    transform: "translate(-545.864 -568.709)",
    fill: "#0077b9"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_3091",
    "data-name": "Group 3091",
    transform: "translate(-15890.07 15599.733)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2648",
    "data-name": "Rectangle 2648",
    width: 73.491,
    height: 1.735,
    fill: "#0077b9"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_3092",
    "data-name": "Group 3092",
    transform: "translate(-15890.07 15607.677)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2649",
    "data-name": "Rectangle 2649",
    width: 73.474,
    height: 1.735,
    fill: "#0077b9"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_3093",
    "data-name": "Group 3093",
    transform: "translate(-15898.671 15598.049)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_4457",
    "data-name": "Path 4457",
    d: "M528.468,769.107l-1.314-1.133a8.567,8.567,0,0,0,0-10.782l1.314-1.133a10.3,10.3,0,0,1,0,13.048Z",
    transform: "translate(-527.154 -756.059)",
    fill: "#0077b9"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_3094",
    "data-name": "Group 3094",
    transform: "translate(-15917.877 15643.421)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2650",
    "data-name": "Rectangle 2650",
    width: 98.376,
    height: 1.735,
    fill: "#0077b9"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_3095",
    "data-name": "Group 3095",
    transform: "translate(-15919.846 15635.478)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2651",
    "data-name": "Rectangle 2651",
    width: 102.314,
    height: 1.735,
    fill: "#0077b9"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_3096",
    "data-name": "Group 3096",
    transform: "translate(-15919.846 15651.364)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2652",
    "data-name": "Rectangle 2652",
    width: 102.314,
    height: 1.735,
    fill: "#0077b9"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_3097",
    "data-name": "Group 3097",
    transform: "translate(-15813.63 15635.759)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_4459",
    "data-name": "Path 4459",
    d: "M796.51,891.127a12.866,12.866,0,0,1,0-17.059l1.279,1.173a11.132,11.132,0,0,0,0,14.713Z",
    transform: "translate(-793.276 -874.068)",
    fill: "#0077b9"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_3099",
    "data-name": "Group 3099",
    transform: "translate(-15950.502 15665.265)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2653",
    "data-name": "Rectangle 2653",
    width: 181.087,
    height: 1.735,
    fill: "#0077b9"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_3100",
    "data-name": "Group 3100",
    transform: "translate(-15944.087 15587.863)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_4461",
    "data-name": "Path 4461",
    d: "M404.817,773.135H402.6V771.4h2.216Zm-4.53,0h-2.314V771.4h2.314Zm-4.627,0h-2.314V771.4h2.314Zm-4.627,0h-2.314V771.4h2.314Zm-4.627,0h-1.373V770.46h1.735v1.808h-.362Zm.362-4.989h-1.735v-2.314h1.735Zm0-4.627h-1.735v-2.314h1.735Zm0-4.627h-1.735v-2.314h1.735Zm0-4.627h-1.735v-2.314h1.735Zm0-4.627h-1.735v-2.314h1.735Zm0-4.627h-1.735V742.7h1.735Zm0-4.627h-1.735V738.07h1.735Zm0-4.627h-1.735v-2.314h1.735Zm0-4.627h-1.735v-2.314h1.735Zm0-4.627h-1.735v-2.314h1.735Z",
    transform: "translate(-385.032 -724.188)",
    fill: "#0077b9"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_3101",
    "data-name": "Group 3101",
    transform: "translate(-15786.901 15603.812)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_4462",
    "data-name": "Path 4462",
    d: "M892.929,813.032H890.8V811.3h.393v-.185h1.735Zm-4.442,0h-2.314V811.3h2.314Zm-4.627,0h-2.314V811.3h2.314Zm-4.627,0h-2.314V811.3h2.314Zm13.7-4.234h-1.735v-2.314h1.735Zm0-4.627h-1.735v-2.314h1.735Zm0-4.627h-1.735V797.23h1.735Zm0-4.627h-1.735V792.6h1.735Zm0-4.627h-1.735v-2.314h1.735Zm0-4.627h-1.735v-2.314h1.735Zm0-4.627h-1.735v-2.314h1.735Zm0-4.627h-1.735v-2.314h1.735Z",
    transform: "translate(-876.919 -774.094)",
    fill: "#0077b9"
  }))))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEducationCdk);
export default __webpack_public_path__ + "static/media/education-cdk.949db2c21f4b3b1dfaaa4dd77f8282a2.svg";
export { ForwardRef as ReactComponent };